













































































import Vue from "vue";
import AccuseDlg from "./AccuseDlg";
export default AccuseDlg;
